/**
 * Heuristik: Gewinnwahrscheinlichkeit aus historischen Abschlüssen pro Quelle (`lead.source`).
 * Ohne ausreichend Daten: Pipeline-Stufe + Angebotsstatus als Fallback.
 */
export function estimateWinProbabilityPercent(lead, allLeads = []) {
  if (!lead) return 0;
  const src = (lead.source || '').trim().toLowerCase();
  if (src && allLeads.length >= 8) {
    const same = allLeads.filter(l => (l.source || '').trim().toLowerCase() === src);
    const won = same.filter(l => l.offerStatus === 'angenommen').length;
    const lost = same.filter(l => l.offerStatus === 'abgelehnt' || String(l.status || '').toLowerCase().includes('verloren')).length;
    const closed = won + lost;
    if (closed >= 3) return Math.round((won / closed) * 100);
  }
  let p = 35;
  const st = (lead.status || '').toLowerCase();
  if (st.includes('kunde')) p = 98;
  else if (st.includes('angebot') || st.includes('termin')) p = 62;
  else if (st.includes('interessiert') || st.includes('nachgefasst')) p = 48;
  else if (st.includes('neu') || st.includes('erstkontakt')) p = 28;
  const os = lead.offerStatus || 'keins';
  if (os === 'in_verhandlung') p = Math.min(88, p + 18);
  if (os === 'versendet') p = Math.min(78, p + 10);
  if (lead.offerAmount && Number(lead.offerAmount) > 5000) p = Math.min(92, p + 5);
  return Math.max(5, Math.min(95, p));
}
